module.exports = __webpack_public_path__ + "img/achievement1.e3562c79.png";